import qs from "qs";
import { useTranslation } from "react-i18next";

import {
  Email,
  Facebook,
  LinkedIn,
  Telegram,
  Twitter,
  WhatsApp,
} from "@/assets/icons/icons";

export const useGetLinks = (
  title: string,
  text: string,
  referralLink?: string,
) => {
  const { t } = useTranslation("portal", {
    keyPrefix: "friendsWithBenefits.groupOverview.sharePanel",
  });

  const createURL = (baseURL: string, params: any) =>
    `${baseURL}?${qs.stringify(params)}`;

  return [
    {
      // Network names stay untranslated; only the mail entry has a real label.
      label: "Facebook",
      icon: <Facebook />,
      link: createURL("https://facebook.com/sharer/sharer.php", {
        u: referralLink,
      }),
    },
    {
      label: "X",
      icon: <Twitter />,
      link: createURL("https://x.com/intent/post", {
        url: referralLink,
        text,
      }),
    },
    {
      label: "Telegram",
      icon: <Telegram />,
      link: createURL("https://telegram.me/share/url", {
        url: referralLink,
        text,
      }),
    },
    {
      label: "WhatsApp",
      icon: <WhatsApp />,
      link: createURL("https://web.whatsapp.com/send", {
        text: `${text} ${referralLink}`,
      }),
    },
    {
      label: "LinkedIn",
      icon: <LinkedIn />,
      link: createURL("https://www.linkedin.com/shareArticle", {
        mini: true,
        url: referralLink,
        source: referralLink,
        title: text,
        summary: text,
      }),
    },
    {
      label: t("email"),
      icon: <Email />,
      link: createURL("mailto:", {
        subject: title,
        body: `${text}\n${referralLink}`,
      }),
    },
  ];
};
